const SemVer = require('../classes/semver')
const minor = (a, loose) => new SemVer(a, loose).minor
module.exports = minor



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/minor.js
// module id = 1415
// module chunks = 0